@if (!savingInProgress()) {
<button mat-icon-button type="button" class="close" mat-dialog-close><mat-icon>close</mat-icon></button>
<h4 mat-dialog-title class="box">{{ 'share.shareMap' | translate }}</h4>
<mat-dialog-content class="mat-typography">
  <div class="">
    <div id="list" class="share-btn-list-container ">
      <div id="contents" role="listbox" class="share-btn-list flex-container container-space-between">
        <!-- Email -->
        <div class="share-item ">
          <a class="share-icon-btn" title="Email"
            href="mailto:?body={{data.encodedCurrentURL}}&amp;subject=Topomapviewer">
            <svg viewBox="0 0 60 60" preserveAspectRatio="xMidYMid meet" focusable="false"
              style="pointer-events: none; display: block; width: 100%; height: 100%;">
              <g fill-rule="nonzero" fill="none">
                <path
                  d="M28.4863253 59.9692983c-6.6364044-.569063-11.5630204-2.3269561-16.3219736-5.8239327C4.44376366 48.4721168 3e-7 39.6467924 3e-7 29.9869344c0-14.8753747 10.506778-27.18854591 25.2744118-29.61975392 6.0281072-.9924119 12.7038532.04926445 18.2879399 2.85362966C57.1386273 10.0389054 63.3436516 25.7618627 58.2050229 40.3239688 54.677067 50.3216743 45.4153135 57.9417536 34.81395 59.5689067c-2.0856252.3201125-5.0651487.5086456-6.3276247.4003916z"
                  fill="#888"></path>
                <path
                  d="M40.531502 19.160814h-22c-1.74 0-2.986 1.2375-3 3v16c0 1.7625 1.26 3 3 3h22c1.74 0 3-1.2375 3-3v-16c0-1.7625-1.26-3-3-3zm0 6l-11 7-11-7v-3l11 7 11-7v3z"
                  fill="#FFF"></path>
              </g>
            </svg>
            <div class="title">Email</div>
          </a>
        </div>
        <!-- Facebook -->
        <!--  onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');"  -->
        <div class="share-item ">
          <a class="share-icon-btn" title="Facebook"
            href="http://www.facebook.com/sharer.php?u={{data.encodedCurrentURL}}&amp;t=Topomapviewer" target="_blank">
            <svg viewBox="0 0 60 60" preserveAspectRatio="xMidYMid meet" focusable="false"
              style="pointer-events: none; display: block; width: 100%; height: 100%;">
              <g fill="none" fill-rule="evenodd">
                <path
                  d="M28.4863253 59.9692983c-6.6364044-.569063-11.5630204-2.3269561-16.3219736-5.8239327C4.44376366 48.4721168 3e-7 39.6467924 3e-7 29.9869344c0-14.8753747 10.506778-27.18854591 25.2744118-29.61975392 6.0281072-.9924119 12.7038532.04926445 18.2879399 2.85362966C57.1386273 10.0389054 63.3436516 25.7618627 58.2050229 40.3239688 54.677067 50.3216743 45.4153135 57.9417536 34.81395 59.5689067c-2.0856252.3201125-5.0651487.5086456-6.3276247.4003916z"
                  fill="#3B5998" fill-rule="nonzero"></path>
                <path
                  d="M25.7305108 45h5.4583577V30.0073333h4.0947673l.8098295-4.6846666h-4.9045968V21.928c0-1.0943333.7076019-2.2433333 1.7188899-2.2433333h2.7874519V15h-3.4161354v.021c-5.3451414.194-6.4433395 3.2896667-6.5385744 6.5413333h-.0099897v3.7603334H23v4.6846666h2.7305108V45z"
                  fill="#FFF"></path>
              </g>
            </svg>
            <div class="title">Facebook</div>
          </a>
        </div>
        <!-- Twitter -->
        <div class="share-item ">
          <a class="share-icon-btn" title="X"
            href="https://twitter.com/intent/tweet?url={{data.encodedCurrentURL}}&amp;text=Topomapviewer"
            target="_blank">
            <svg viewBox="0 0 60 60" preserveAspectRatio="xMidYMid meet" focusable="false"
              style="pointer-events: none; display: block; width: 100%; height: 100%;">
              <g fill="none" fill-rule="evenodd">
                <path
                  d="M28.486325 59.969298c-6.636404-.569063-11.56302-2.326956-16.321973-5.823932C4.443764 48.472116 0 39.646792 0 29.986934 0 15.11156 10.506778 2.798388 25.274412.36718c6.028107-.992411 12.703853.049265 18.28794 2.85363 13.576275 6.818095 19.7813 22.541053 14.64267 37.103159-3.527955 9.997705-12.789708 17.617785-23.391072 19.244938-2.085625.320112-5.065149.508645-6.327625.400391z"
                  fill="#000000" fill-rule="nonzero"></path>
                <path fill="#ffffff"
                  d="M33.2,28l11-12.8h-2.6l-9.5,11.1-7.6-11.1h-8.8l11.5,16.8-11.5,13.4h2.6l10.1-11.7,8.1,11.7h8.8l-12-17.4h0ZM29.6,32.2l-1.2-1.7-9.3-13.3h4l7.5,10.7,1.2,1.7,9.8,13.9h-4l-8-11.4h0Z" />
              </g>
            </svg>
            <div class="title">X</div>
          </a>
        </div>
        <!-- WhatsApp -->
        <div class="share-item ">
          <a class="share-icon-btn" title="WhatsApp" href="https://wa.me/?text={{data.encodedCurrentURL}}"
            target="_blank">
            <svg viewBox="0 0 61 61" preserveAspectRatio="xMidYMid meet" focusable="false"
              style="pointer-events: none; display: block; width: 100%; height: 100%;">
              <g fill="none" fill-rule="evenodd">
                <circle fill="#25D366" cx="30" cy="30" r="30" />
                <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFFFFF"
                  d="M41.361,18.646c-3.015-3.017-7.022-4.68-11.293-4.682
                                    c-8.8,0-15.961,7.162-15.964,15.962c-0.002,2.814,0.733,5.561,2.131,7.983l-2.265,8.272l8.463-2.222
                                    c2.332,1.272,4.957,1.942,7.629,1.945h0.006h0c8.797,0,15.96-7.162,15.964-15.966C46.034,25.674,44.375,21.663,41.361,18.646
                                     M30.067,43.207h-0.006c-2.38,0-4.715-0.64-6.753-1.85l-0.484-0.287l-5.022,1.317l1.34-4.896l-0.315-0.502
                                    c-1.328-2.112-2.03-4.554-2.029-7.061c0.003-7.316,5.956-13.269,13.275-13.269c3.544,0.001,6.876,1.384,9.381,3.891
                                    c2.505,2.508,3.883,5.842,3.882,9.386C43.333,37.255,37.38,43.207,30.067,43.207 M37.345,33.27c-0.397-0.199-2.36-1.165-2.726-1.297
                                    c-0.364-0.134-0.632-0.201-0.897,0.199c-0.266,0.399-1.029,1.297-1.263,1.564c-0.232,0.266-0.465,0.299-0.865,0.1
                                    c-0.397-0.201-1.683-0.62-3.207-1.98c-1.186-1.058-1.986-2.364-2.219-2.763c-0.233-0.4-0.024-0.615,0.174-0.814
                                    c0.18-0.178,0.399-0.466,0.599-0.698c0.2-0.233,0.266-0.399,0.399-0.667c0.132-0.266,0.067-0.499-0.034-0.698
                                    c-0.099-0.2-0.897-2.164-1.229-2.962c-0.324-0.777-0.653-0.672-0.898-0.685c-0.232-0.011-0.499-0.014-0.764-0.014
                                    c-0.266,0-0.699,0.1-1.064,0.499c-0.366,0.399-1.396,1.364-1.396,3.328c0,1.963,1.429,3.86,1.629,4.126
                                    c0.199,0.266,2.812,4.296,6.814,6.023c0.95,0.412,1.693,0.656,2.273,0.841c0.956,0.303,1.825,0.26,2.513,0.158
                                    c0.766-0.115,2.359-0.967,2.692-1.897c0.333-0.932,0.333-1.73,0.233-1.896C38.01,33.569,37.745,33.469,37.345,33.27" />
              </g>
            </svg>
            <div class="title">WhatsApp</div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- QR Code -->
  <div style="display: flex; justify-content: center;">
    <qrcode [qrdata]="data.currentURL" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
    <!--  [colorDark]="'#ffffff'"   [colorLight]="'#000000'"-->
  </div>
  <br>
  <!-- URL field -->
  <div id="copy-link" class="">
    <div class="style-scope yt-third-party-network-section-renderer" renderer-style="">
      <div id="bar" class="">
        <input #copylink id="share-url" readonly (click)="copylink.setSelectionRange(0, 999)" size="45"
          class="share-input" [value]="data.currentURL">
        <button mat-button class="tertiary-button" (click)="copyToClipboard(copylink)">{{ 'share.copyLink' | translate
          }}</button>
      </div>
    </div>
  </div>
  <br>
  <!-- Error message  -->
  @if (savingFailed()) {
  <p style="display: flex; justify-content: center; color: var(--mat-sys-error)">
    {{ savingErrorMessage }}</p>
  <p style="display: flex; justify-content: center; color: var(--mat-sys-error)">
    {{ 'share.saving-failed' | translate }}</p>
  }
</mat-dialog-content>
<!-- Action buttons (close, ...) -->
<mat-dialog-actions align="center" class="">
  <div class="button-container">
    <a mat-button mat-dialog-close class="close-tip">&nbsp;{{"general.close"|translate}} </a>
  </div>
</mat-dialog-actions>
}

<!-- Loading spinner  -->
@if (savingInProgress()) {
<button mat-icon-button type="button" class="close" mat-dialog-close><mat-icon>close</mat-icon></button>
<h4 mat-dialog-title class="box">{{ 'share.shareMap' | translate }}</h4>
<mat-dialog-content class="mat-typography">
  <div style="width:295px">
    <div id="list" class="share-btn-list-container ">
      <div style="display:flex; flex-direction: column; align-items: center;justify-content: center;height: 600px;">
        <!-- <mat-dialog-content class="mat-typography"> -->
        <mat-spinner diameter="50" color="accent"></mat-spinner>
        <span style="margin-top:25px">{{ 'share.saving-route' | translate }} ...</span>
        <!-- </mat-dialog-content> -->
      </div>
    </div>
  </div>
</mat-dialog-content>
}